import { JavaScripttoXML } from "../serialize";
import { format as formatDate } from "../date";
import { words } from "../number";
import { isGuid } from "../string";

export const CHECK_TEMPLATE_UUID = "cf6e52c0-d55e-11ed-a3e9-0efa9373c42b";

export const buildPrintableCheck = ({
  amount,
  checkDate,
  checkNumber,
  memo,
  payeeName,
  payeeAddress,
  referenceNumber,
  ...rest
} = {}) => {
  const numericAmount = Number(amount || 0);
  const number = checkNumber || rest.number || "";
  const payee = payeeName || rest.payee || "";

  return {
    ...rest,
    amount: numericAmount,
    checkDate,
    checkNumber: number,
    number,
    payeeName: payee,
    payee,
    payeeAddress: payeeAddress || "",
    memo: memo || "",
    referenceNumber: referenceNumber || "",
    words: words(numericAmount, true, true),
  };
};

export const downloadCheckPdf = async ({
  render,
  check,
  fileName,
  templateUuid,
}) => {
  const printable = buildPrintableCheck(check);
  const rendered = await render({
    uuid: isGuid(templateUuid) ? templateUuid : CHECK_TEMPLATE_UUID,
    xml: JavaScripttoXML(printable),
    output: "XSL",
  });

  const blob = rendered instanceof Blob ? rendered : new Blob([rendered], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute(
    "download",
    fileName || `${formatDate(printable.checkDate)} Check ${printable.number || printable.payee || "Check"}.pdf`
  );
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(url);

  return printable;
};
